/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { BulkStoresAmenitiesRequest } from '../../models/bulk-stores-amenities-request';
import { BulkStoresAmenitiesResponse } from '../../models/bulk-stores-amenities-response';

export interface BulkStoresAmenities$Params {
  'Active-Tenant-Identifier': string;
      body: BulkStoresAmenitiesRequest
}

export function bulkStoresAmenities(http: HttpClient, rootUrl: string, params: BulkStoresAmenities$Params, context?: HttpContext): Observable<StrictHttpResponse<BulkStoresAmenitiesResponse>> {
  const rb = new RequestBuilder(rootUrl, bulkStoresAmenities.PATH, 'post');
  if (params) {
    rb.header('Active-Tenant-Identifier', params['Active-Tenant-Identifier'], {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<BulkStoresAmenitiesResponse>;
    })
  );
}

bulkStoresAmenities.PATH = '/bulk-stores-amenities';
